import { Button } from '@mui/material';
import { useConnectToAnrok } from '../../hooks/connect-to-anrok';
import type { AnrokRegisterFormControl } from '../AnrokRegisterFormSchema';

interface Props {
  control: AnrokRegisterFormControl;
}

export const AnrokRegistrationFooter = ({ control }: Props) => {
  const connectToAnrok = useConnectToAnrok(control);
  const { handleSubmit } = control;
  const submitHandler = handleSubmit((formValues) =>
    connectToAnrok(formValues.apiKey, formValues.defaultExternalProductId),
  );

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button variant="contained" onClick={submitHandler}>
        Connect to Anrok
      </Button>
    </div>
  );
};
